/**
 * GROWTH:CODE 共通背景
 *
 * 仕様: docs/spec/design_spec.md §3.1 / §4.2
 *   - 初期リリースは Celestial 1 系統固定 (パステル多色グラデーション)
 *   - 将来は系統テーマで差し替え可
 */
const Bg = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        background:
          "var(--gradient-celestial, linear-gradient(135deg, #e8f4ff 0%, #fff8e1 50%, #fff1e6 100%))",
        zIndex: -1,
      }}
    />
  );
};

export default Bg;
